<template>
  <section>
    <b-modal
        id="evrak1"
        ref="modal1"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('malzeme-talep')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('malzeme-talep-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Malzeme Talep Formu"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="malzeme-talep"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="malzeme-talep-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">MALZEME TALEP FORMU</p>
            </b-col>
            <b-col cols="12">
              <p class="my-50 font-size-13">Belge Tarih Ve Sayısı : {{ bilgiler.belgeTarihSayi }}</p>
            </b-col>
            <b-col cols="12">
              <p class="my-2 text-center font-size-17">
                {{ $store.getters.FIRMA_BILGILERI.tamUnvan }}
              </p>
            </b-col>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th scope="col">Satın Alınacak Malzemenin Cinsi</th>
                <th scope="col">Miktarı</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ bilgiler.ihaleBaslik }}</td>
                <td>{{ detay.isMiktar }}</td>
              </tr>
              </tbody>
            </table>
            <b-col cols="12">
              <p class="my-2 font-size-13">Kurumumuz {{ bilgiler.ilgiliBirim }} için yukarıdaki cins ve miktarı
                yazılı malzemenin
                satın alınmasını arz ederim.</p>
              <hr/>
            </b-col>


            <table class="table table-bordered">
              <thead>
              <tr class="text-center">
                <th scope="col">Komisyon Üyesi</th>
                <th scope="col">Komisyon Üyesi</th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center">
                <td>
                  <p class="my-50 text-center mx-5 font-size-13">Yukarıda belirtilen malzemelerin alınması için İhaleye
                    çıkılması
                    hususunu Olurlarınıza arz ederim.</p>
                  <p class="my-1 text-center font-size-13">{{ bilgiler.belgeTarih }}</p>
                  <p class="m-0 text-center font-size-14" v-if="evraklar(1).sira.sira2">
                    {{
                      evraklar(1).sira.sira2.adSoyad
                    }}</p>
                  <p class="text-center font-size-14" v-if="evraklar(1).sira.sira1">{{
                      evraklar(1).sira.sira2.unvan
                    }}</p>
                </td>
                <td>
                  <p class="mt-1 mb-0 text-center font-size-13">Uygundur.</p>
                  <p class="m-0 text-center font-size-13" v-if="bilgiler.ihaleYetkilisi">{{ bilgiler.belgeTarih }}</p>
                  <p class="mt-1 mb-0 text-center font-size-14" v-if="evraklar(1).sira.sira1">{{
                      evraklar(1).sira.sira1.adSoyad
                    }}</p>
                  <p class="m-0 text-center font-size-14" v-if="evraklar(1).sira.sira1">{{
                      evraklar(1).sira.sira1.unvan
                    }}</p>
                </td>
              </tr>
              </tbody>
            </table>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak2"
        ref="modal2"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('satin-alma')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('satin-alma-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Satın Alma Komisyon Üyeleri"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="satin-alma"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="satin-alma-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">SATIN ALMA KOMİSYON ÜYELERİ</p>
            </b-col>
            <b-col cols="12">
              <p class="my-2 text-center font-weight-bolder font-size-15">{{ $store.getters.FIRMA_BILGILERI.tamUnvan }}
                Doğrudan
                temin
                ile satın alınacak “{{ bilgiler.ihaleBaslik }}” satın alma komisyonu aşağıda belirtilen isimlerden
                oluşmuştur.
              </p>
            </b-col>
            <b-col class="offset-6" cols="6" v-if="evraklar(2).sira.sira1">
              <p class="mt-1 mb-0 text-center font-size-13">{{ bilgiler.belgeTarih }}</p>
              <p class="m-0 text-center text-decoration-underline font-size-14">İhale Yetkilisi</p>
              <p class="mt-50 mb-0 text-center font-size-14">{{ bilgiler.ihaleYetkilisi }}</p>
              <p class="m-0 text-center font-size-14">{{ bilgiler.yetkiliUnvan }}</p>
            </b-col>
            <table class="table table-striped table-hover mt-2 table-bordered">
              <thead>
              <tr>
                <th class="text-center" v-for="uye in lodash.orderBy(evraklar(2).evrakUyeleri, 'sira', 'asc')"
                    :key="uye.siraNo"
                    scope="col"
                >Komisyon Üyesi
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center" v-for="uye in lodash.orderBy(evraklar(2).evrakUyeleri, 'sira', 'asc')"
                    :key="uye.siraNo"
                >
                  {{ uye.gorev }}
                  {{ uye.adSoyad }}
                  {{ uye.unvan }}
                </td>
              </tr>
              </tbody>
            </table>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak3"
        ref="modal3"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('fiyat-arastirma')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('fiyat-arastirma-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Fiyat Araştırma Tespit Tutanağı"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="fiyat-arastirma"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="fiyat-arastirma-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">PİYASA FİYAT ARAŞTIRMA (TESPİT) TUTANAĞI </p>
            </b-col>
            <b-col cols="12">
              <p class="font-size-13">
                Kurumumuz {{ $store.getters.FIRMA_BILGILERI.tamUnvan }} Müdürlüğü tarafından 4734 Sayılı Kamu İhale
                Kanununun 22/d maddesi gereğince, “{{ detay.ihaleUsulu }}” usulüyle satın alınması düşünülen aşağıda
                cinsi ve
                miktarı yazılı mal, hizmet ya da işin yaklaşık maliyetinin tespit edilmesinde değerlendirilmesi için;
              </p>
            </b-col>
            <b-col cols="12">
              <p class="text-center font-size-13">
                KDV hariç olmak üzere, piyasa satış birim fiyatlarınızı toplamları ile birlikte bildirilmenizi rica
                ederiz.
              </p>
            </b-col>

            <table class="table table-bordered">
              <thead>
              <tr class="text-center">
                <th v-for="uye in lodash.orderBy(evraklar(3).evrakUyeleri, 'sira', 'asc')" :key="uye.siraNo"
                    scope="col"
                >
                  Komisyon Üyesi
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center">
                <td v-for="uye in lodash.orderBy(evraklar(3).evrakUyeleri, 'sira', 'asc')" :key="uye.siraNo">
                  {{ uye.gorev }}
                  {{ uye.adSoyad }}
                  {{ uye.unvan }}
                </td>
              </tr>
              </tbody>
            </table>
            <b-col cols="12" class="mt-1">
              <table class="table table-striped table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">S. No</th>
                  <th scope="col">Mal, Hizmet ya da İşin Cinsi</th>
                  <th scope="col">Miktarı ve Birimi</th>
                  <th scope="col">KDV %'si</th>
                  <th scope="col">Birim Fiyat TL (KDV Hariç)</th>
                  <th scope="col">Toplam Fiyat TL (KDV Hariç)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in kalemler" :key="item.kalemID">
                  <td class="p-0 fiyat-arastirma-td-1"> {{ i + 1 }}</td>
                  <td class="p-0 fiyat-arastirma-td-2"> {{ item.kalemAdi }}</td>
                  <td class="p-0 fiyat-arastirma-td-3"> {{ item.miktar }} {{ item.birimTuru }}</td>
                  <td class="p-0 fiyat-arastirma-td-4"></td>
                  <td class="p-0 fiyat-arastirma-td-5"></td>
                  <td class="p-0 fiyat-arastirma-td-6"></td>
                </tr>
                </tbody>
              </table>
              <tr class="fiyat-arastirma-tr">
                <td class="fiyat-arastirma-td-last p-0">
                  <p style="margin:7px">Genel Toplam Fiyat (KDV Hariç)</p>
                </td>
                <td style="width: 20%;border: 1px solid #f2f2ff" class="p-0"></td>
              </tr>
            </b-col>
            <b-col cols="12" class="mt-1">
              <p class="text-center font-size-13">Yukarıda cinsi ve miktarı yazılı malzemelerin piyasa fiyatı
                ilgili
                kamu kurum ve
                kuruluşu, esnaf ve serbest piyasadan alınmıştır.</p>
            </b-col>
            <b-col cols="12" class="mt-2 text-center">
              <p class="text-center font-weight-bolder d-inline-block font-size-14">Firma Adı </p>
              <p class="d-inline-block pl-2">: .........................................................</p>
            </b-col>
            <b-col cols="12" class="mt-50 text-center">
              <p class="text-center font-weight-bolder d-inline-block font-size-14">Ticari Unvan</p>
              <p class="d-inline-block pl-2">: .........................................................</p>
            </b-col>
            <b-col cols="12" class="mt-50 text-center">
              <p class="text-center font-weight-bolder d-inline-block font-size-14">Kaşe/İmza</p>
              <p class="d-inline-block pl-2">: .........................................................</p>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        v-if="teklifler.length > 0"
        id="evrak4"
        ref="modal4"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('maliyet-hesaplama')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('maliyet-hesaplama-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Yaklaşık Maliyet Hesaplama Tablosu"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="maliyet-hesaplama"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="maliyet-hesaplama-formu">
          <b-row v-if="show" class="p-2 pr-5 pl-5">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">YAKLAŞIK MALİYET HESAPLAMA TABLOSU</p>
            </b-col>
            <table class="table table-striped table-hover table-bordered">
              <thead>
              <tr class="text-center">
                <th class="p-0" scope="col"><p class="m-0">Malzemenin Adı</p></th>
                <th class="p-0" scope="col"><p class="m-0">Miktarı</p></th>
                <th v-for="(item,i) in teklifler" :key="item.firmaID" class="p-0" scope="col" style="max-width: 140px;">
                  {{ i + 1 }}.Firma
                  <hr class="m-0">
                  {{ formatFirmaBilgileri(item.firmaBilgileri) }}
                </th>
                <th class="p-0" scope="col"><p class="m-0">Ortalama Fiyat</p></th>
                <th class="p-0" scope="col"><p class="m-0">Nihai Fiyat</p></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in yaklasikMaliyet.liste" :key="i">
                <td class="p-0 text-center">{{ item.kalemAdi }}</td>
                <td class="p-0 text-center">{{ item.miktar }} {{ item.birimTuru }}</td>
                <td v-for="(teklif) in teklifler" :key="teklif.firmaID" class="p-0 text-center">
                  <p class="m-0">
                    {{ getTeklifBirimFiyat(teklif, item.kalemID) }}
                  </p>
                </td>
                <td class="p-0 text-center"> {{ item.birimFiyat }} TL</td>
                <td class="p-0 text-center"> {{ item.toplamFiyat }} TL</td>
              </tr>
              <tr>
                <td :colspan="teklifler.length + 3" class="p-0 text-center">
                  <p class="m-0 p-50 font-weight-bolder">Toplam Fiyat TL</p>
                </td>
                <td colspan="1" class="p-0 text-center">
                  <p class="m-0 p-50 font-weight-bolder">{{ yaklasikMaliyet.araToplam }} TL</p>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table mt-1 table-bordered">
              <thead>
              <tr class="text-center">
                <th v-for="uye in lodash.orderBy(evraklar(4).evrakUyeleri, 'sira', 'asc')" :key="uye.siraNo"
                    scope="col"
                >Komisyon Üyesi
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center">
                <td v-for="uye in lodash.orderBy(evraklar(4).evrakUyeleri, 'sira', 'asc')" :key="uye.siraNo">
                  {{ uye.gorev }}
                  {{ uye.adSoyad }}
                  {{ uye.unvan }}
                </td>
              </tr>
              </tbody>
            </table>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak5"
        ref="modal5"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('ihale-onay')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('ihale-onay-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="İhale Onay Belgesi"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="ihale-onay"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="ihale-onay-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">İHALE ONAY BELGESİ</p>
            </b-col>
            <table class="table table-bordered mb-1">
              <thead>
              <tr class="d-none">
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="p-0"><p class="m-0 font-weight-bolder ml-1">İhaleyi yapan kurumun adı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ $store.getters.FIRMA_BILGILERI.tamUnvan }}</p>
                </td>
              </tr>
              <tr>
                <td class="p-0"><p class="m-0 font-weight-bolder ml-1">Belge tarih ve sayısı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ bilgiler.belgeTarihSayi }}</p></td>
              </tr>
              <tr>
                <td colspan="2" class="p-50 text-center"><p class="m-0 ml-1 font-weight-bolder">
                  {{ $store.getters.FIRMA_BILGILERI.tamUnvan }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="m-0 font-weight-bolder ml-1">İşin Tanımı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.isTanim }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="m-0 font-weight-bolder ml-1">İşin Tanımı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.isNitelik }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="m-0 font-weight-bolder ml-1">İşin Miktarı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.isMiktar }}</p></td>
              </tr>
              <tr>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Yatırım Proje Numarası (varsa)</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.projeNo }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Bütçe Tertibi (varsa)</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.butceTertibi }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Avans Verilecekse Şartları</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.avansSartlari }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">İhale Usulü</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.ihaleUsulu }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">İlanın Şekli ve Adedi</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.ilanSekliAdeti }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Ön Yeterlik/İhale Dokümanı Satış Bedeli</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.dokumanSatisBedeli }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Fiyat Farkı Ödenecekse Dayanağı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.fiyatFarkDayanagi }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">Bakanlar Kurulu Kararı</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.bakanlarKuruluKarari }}</p></td>
              </tr>
              <tr>
                <td class="p-0"><p class="ml-1 m-0">İhale İle İlgili Diğer Açıklamalar</p></td>
                <td class="p-0"><p class="m-0 ml-1 font-weight-bolder">{{ detay.digerAciklamalar }}</p></td>
              </tr>
              <tr>
                <td colspan="2"><p class="font-weight-bolder p-50 m-0 text-center">Onay</p></td>
              </tr>
              <tr>
                <td class="p-0" v-if="evraklar(5).sira.sira1">
                  <p class="my-50 text-center mx-5 font-size-13">Yukarıda belirtilen malzemelerin alınması için
                    İhaleye
                    çıkılması
                    hususunu Olurlarınıza arz ederim.</p>
                  <p class="my-1 text-center font-size-14">{{ bilgiler.belgeTarih }}</p>
                  <p class="m-0 text-center font-size-14">{{ evraklar(5).sira.sira1.adSoyad }}</p>
                  <p class="text-center font-size-14">{{ evraklar(5).sira.sira1.unvan }}</p>
                </td>
                <td class="p-0" v-if="bilgiler.ihaleYetkilisi">
                  <p class="mt-1 mb-0 text-center font-size-13">Uygundur.</p>
                  <p class="m-0 text-center font-size-14">{{ bilgiler.belgeTarih }}</p>
                  <p class="mt-1 mb-0 text-center font-size-14">{{ bilgiler.ihaleYetkilisi }}</p>
                  <p class="m-0 text-center font-size-14">{{ bilgiler.yetkiliUnvan }}</p>
                </td>
              </tr>
              </tbody>
            </table>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak6"
        ref="modal6"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('birim-fiyat-mektubu')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('birim-fiyat-mektubu-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Birim Fiyat Teklif Mektubu"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="birim-fiyat-mektubu"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="birim-fiyat-mektubu-formu">
          <b-row class="pr-5 pl-5" v-if="show">
            <b-col cols="12" class="d-flex justify-content-end">
              <p class="text-center font-size-13">.... / .... / {{ currentYear }}</p>
            </b-col>
            <b-col cols="12">
              <p class="text-center font-size-17">BİRİM FİYAT TEKLİF MEKTUBU</p>
            </b-col>
            <b-col cols="12">
              <p class="text-center font-size-16">{{ $store.getters.FIRMA_BILGILERI.tamUnvan }}
              </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder text-decoration-underline font-size-14">TEKLİF SAHİBİNİN</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder">Adı Soyadı : </p>
              <p class="font-weight-bolder">Firma Unvanı / Uyruğu : </p>
              <p class="font-weight-bolder">Açık Tebligat Adresi : </p>
              <p class="font-weight-bolder">Bağlı Olduğu Vergi Dairesi : </p>
              <p class="font-weight-bolder">Vergi Numarası : </p>
              <p class="font-weight-bolder">Telefon ve Faks Numarası : </p>
              <hr>
            </b-col>
            <b-col cols="12">
              <p class="font-size-13"> Tarafınızdan ihale dokümanı oluşturan bütün belgeler incelenmiş, okunmuş ve
                herhangi bir ayrım ve
                sınırlama yapmadan bütün koşullarıyla kabul edilmiştir. İhaleye çıkarılan “E-Fatura Modülü ve
                Entegrasyonu” işine ilişkin olarak aşağıdaki hususları içeren teklifimizin kabulünü arz ederim.</p>
            </b-col>
            <b-col cols="12" class="p-50 font-size-13">1. Teklifimiz
              .................................................................................... tarihleri arasında
              geçerlidir.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">2. Teklifimize nakliye, taşıma, yerleştirme, istifleme ve kurulum
              gibi işler
              dahildir.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">3. İhale konsu iş için sermayesinin %50'sinden fazlasına sahip
              olduğumuz başka
              bir tüzel
              kişinin bu işe ayrı bir teklif vermediğini beyan ediyoruz.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">4. Aldığımız herhangi bir teklifi veya en düşün teklifi seçmek
              zorunda
              olmadığımızı kabul
              ediyoruz.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">5. İhale konusu iş ile ilgili olmak üzere idarenizce yaptırılacak
              diğer
              işlerde, idarenizin
              çıkarlarına aykırı düşecek hiçbir eylem ve oluşum içinde olmayacağımızı taahhüt ediyoruz.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">6. 4734 sayılı Kamu İhale Kanununu çerçevesinde yerli ya da
              yabancı istekli
              durumunda
              olduğumuzu beyan ediyoruz.
            </b-col>
            <b-col cols="12" class="p-25 font-size-13">7. Teklifimizde yer alan ürünlerin 4734 sayılı Kamu İhale
              Kanununu
              çerçevesinde yerli malı
              olup olmadığını beyan ediyoruz.
            </b-col>
            <b-col cols="12" class="font-size-13">8. İhale konusu mal, hizmet ya da iş, birim fiyatlar üzerinden
              teklif
              ettiğimiz, KDV hariç
              rakam ile ........................................ TL yazı ile
              ....................................................... TL
              toplam bedel olup, toplam bedelin ayrıntısı teklif mektubumuzun ekindeki cetveldedir.
            </b-col>
            <b-col cols="12" class="mb-1">Saygılarımızla;
            </b-col>
            <b-col cols="6" class="d-flex text-center justify-content-center">
              <p class="font-size-14">Eki- Birim Fiyat Teklif Cetveli</p>
            </b-col>
            <b-col cols="6" class="justify-content-center d-flex text-center">
              <b-row>
                <b-col cols="12">
                  <p class="d-block font-size-14">Teklif Sahibi</p>
                </b-col>
                <b-col cols="12">
                  <p class="d-block font-size-14">Firma-Kaşe-İmza</p>
                </b-col>
              </b-row>
              <br/>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak7"
        ref="modal7"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('birim-fiyat-cetveli')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('birim-fiyat-cetveli-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Birim Fiyat Cetveli"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="birim-fiyat-cetveli"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="birim-fiyat-cetveli-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12">
              <p class="text-center font-size-17 m2-4">BİRİM FİYAT TEKLİF CETVELİ</p>
            </b-col>
            <b-col cols="12" class="mb-1">
              <p class="font-weight-bolder font-size-13 m-0">Kurumumuz {{ $store.getters.FIRMA_BILGILERI.tamUnvan }}
                Müdürlüğü tarafından
                aşağıda cinsi, özellikleri ve miktarları yazılı mal, hizmet ya da iş; 4734 Sayılı Kamu İhale Kanunu'nun
                22/d maddesi gereğince {{ detay.ihaleUsulu }} usulüyle satın alınacaktır.
              </p>
              <p class="font-weight-bolder m-0 text-center font-size-13">İlgilenmeniz halinde KDV hariç teklif birim
                fiyatlarınızı
                toplamları ile birlikte bildirilmenizi rica
                ederiz.</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th scope="col" v-for="uye in lodash.orderBy(evraklar(7).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                      class="text-center"
                  >Komisyon Üyesi
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="uye in lodash.orderBy(evraklar(7).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                  >
                    <p class="text-center text-decoration-underline font-size-10 m-0">{{ uye.gorev }}</p>
                    <p class="m-0 text-center font-weight-bolder font-size-12">{{ uye.adSoyad }}</p>
                    <p class="m-0 text-center font-weight-bold font-size-10">{{ uye.unvan }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="mt-1">
              <table class="table table-bordered table-hover table-striped">
                <thead>
                <tr>
                  <th scope="col">S. No</th>
                  <th scope="col">Mal, Hizmet ya da İşin Cinsi</th>
                  <th scope="col">Miktarı ve Birimi</th>
                  <th scope="col">KDV %’si</th>
                  <th scope="col">Birim Fiyat TL (KDV hariç)</th>
                  <th scope="col"> Toplam Fiyat TL (KDV hariç)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in kalemler" :key="item.kalemID" class="text-center">
                  <td class="p-0">{{ i + 1 }}</td>
                  <td class="p-0">{{ item.kalemAdi }}</td>
                  <td class="p-0">{{ item.miktar }} {{ item.birimTuru }}</td>
                  <td class="p-0">{{ item.kdv }}</td>
                  <td class="p-0">{{ item.kdv }}</td>
                  <td class="p-0"></td>
                </tr>
                <tr>
                  <td colspan="5" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder">Genel Toplam Fiyat (KDV Hariç)</p>
                  </td>
                  <td colspan="1" class="p-0 text-center">
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12">
              <p class="text-center font-size-13">VERİLECEK TEKLİF ŞARTLARI</p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">
                1. Teklifler KDV hariç verilecek ve toplam fiyat üzerinden
                değerlendirilecektir.
              </p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">2. Kısmi teklif verilemez veya kısmi mal alınamaz. Kaşesi ya da adı soyadı,
                unvanı, adresi ve imzası olmayanlar ile silinti, kazıntı olan teklifler değerlendirilmeyecektir.
              </p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">3. Kurumumuza alınacak mal, hizmet ya da iş standartlara uygun olacak ve
                komisyonumuz tarafından sayımı, muayenesi ve uygunluk kontrolleri yapılacaktır uygun olmayan mal hizmet
                ya
                da iş kabul edilmeyecektir. Uygun olmayan ürünlerin gerilmesinin tekrarı halinde ise ihale tek taraflı
                olarak fesh edilecektir.
              </p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">4. Kurumumuza günlük gelecek olan perakende malzemeler sipariş fişi ile
                birlikte gelecek ve görevlilere imza karşılığı teslim edilecektir.
              </p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">5. Günlük sipariş fişleri ile gelen perakende malzemelerin faturası teklif
                edilen fiyat üzerinden ayda bir gerekirse 15 günde bir kesilecek ve peşin ödenecektir. Toptan gelen
                malzemelern ise tamamı teslim alındıktan sonra teklif edilen fiyat üzerinden faturası kesilecek ve peşin
                ödenecektir.</p>
            </b-col>
            <b-col cols="12" class="p-0">
              <p class="font-size-13 mb-0">6. Perakende alımlarda piyasa fiyatlarındaki değişkenlikler nedeniyle gerekli
                görüldüğü taktirde önceden haber verilmesi şartıyla teklif edilen toplam fiyat dolmasa da ihale tek
                taraflı olarak yeniden tazelenmek üzere fesh edilebilir. Aksi taktirde ise teklif edilen toplam fiyatın
                dolumunda ihale sona erecektir.
              </p>
            </b-col>
            <b-col cols="6" class="justify-content-center offset-6 d-flex text-center pt-50">
              <b-row>
                <b-col cols="12">
                  <p class="d-block font-size-14">Teklif Sahibi</p>
                </b-col>
                <b-col cols="12">
                  <p class="d-block font-size-14">Firma-Kaşe-İmza</p>
                </b-col>
              </b-row>
              <br/>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak8"
        ref="modal8"
        centered
        size="xl"
        hide-footer
        v-if="teklifler.length != 0"
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('yaklasik-maliyet')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('yaklasik-maliyet-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Yaklaşık Maliyet Hesaplama Tablosu"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="yaklasik-maliyet"
          id="html2Pdf"
      >
        <section slot="pdf-content" class="pl-2 pr-2" ref="yaklasik-maliyet-formu">
          <b-row class="pr-5 pl-5" v-if="show">
            <b-col cols="12">
              <p class="text-center font-size-17 mt-4">YAKLAŞIK MALİYET HESAP CETVELİ</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-bordered table-striped table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col"> Birim Fiyata Esas İş Kaleminin Adı</th>
                  <th scope="col" class="text-center"> Miktarı</th>
                  <th scope="col" class="text-center"> Birim Fiyatı (TL)</th>
                  <th scope="col" class="text-center"> Tutarı (TL)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in yaklasikMaliyet.liste" :key="item.kalemID">
                  <td class="p-0"><p class="ml-1 mb-0"> {{ item.kalemAdi }}</p></td>
                  <td class="p-0 text-center"> {{ item.miktar }} {{ item.birimTuru }}</td>
                  <td class="p-0 text-center"> {{ item.birimFiyat }} TL</td>
                  <td class="p-0 text-center"> {{ item.toplamFiyat }} TL</td>
                </tr>
                <tr>
                  <td colspan="3" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder">Genel Toplam Fiyat (KDV Hariç)</p>
                  </td>
                  <td colspan="1" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder">{{ yaklasikMaliyet.araToplam || 0 }} TL</p>
                  </td>
                </tr>
                <tr v-for="(item,i) in yaklasikMaliyet.kdvOrani" :key="i">
                  <td colspan="3" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder">KDV ({{ item.kdvOrani }})</p>
                  </td>
                  <td colspan="1" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder"> {{ item.toplamVergi }} TL</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder">Genel Toplam (KDV dahil)</p>
                  </td>
                  <td colspan="1" class="p-0 text-center">
                    <p class="m-0 p-50 font-weight-bolder"> {{ yaklasikMaliyet.genelToplam || 0 }} TL</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="text-center font-size-14 p-50">Yukarıda cins ve miktarı yazılı mal ve malzemelerin
              yaklaşık
              maliyeti piyasa araştırılması yapılarak hesaplanmıştır. {{ bilgiler.belgeTarih }}
            </b-col>
            <b-col cols="12">
              <table class="table table-bordered table-hover table-striped">
                <thead>
                <tr>
                  <th v-for="uye in lodash.orderBy(evraklar(8).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo" scope="col" class="text-center"
                  >Komisyon Üyesi
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="p-0" v-for="uye in lodash.orderBy(evraklar(8).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                  >
                    <p class="text-center text-decoration-underline font-size-14">{{ uye.gorev }}</p>
                    <p class="m-0 text-center font-weight-bolder font-size-14">{{ uye.adSoyad }}</p>
                    <p class="m-0 text-center font-weight-bold font-size-14">{{ uye.unvan }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        v-if="teklifler.length != 0"
        id="evrak9"
        ref="modal9"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('katilanlari-belirleme')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('katilanlari-belirleme-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="İhaleye Katılanları Belirleme"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="katilanlari-belirleme"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="katilanlari-belirleme-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">İHALEYE KATILANLARI BELİRLEME TUTANAĞI</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder">İhale Kayıt No : {{ bilgiler.belgeTarihSayi }}</p>
              <p class="font-weight-bolder">İdarenin Adı : {{ $store.getters.FIRMA_BILGILERI.tamUnvan }}</p>
              <p class="font-weight-bolder">İşin Adı : {{ bilgiler.ihaleBaslik }}</p>
              <p class="font-weight-bolder">Formun Doldurulduğu Tarih : {{ bilgiler.belgeTarih }}</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-bordered table-striped table-hover">
                <thead>
                <tr>
                  <th scope="col">S. No</th>
                  <th scope="col">Teklif Verenlerin Adı Soyadı ve Unvanı</th>
                  <th scope="col"> Teklif Bedeli</th>
                  <th scope="col"> Teklif Bedeli (KDV dahil)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in teklifler" :key="item.atamaID">
                  <td class="p-25">{{ i + 1 }}</td>
                  <td class="p-25"> {{ item.firmaBilgileri.firmaUnvan || item.firmaBilgileri.firmaAdi }}</td>
                  <td class="p-25"> {{ item.firmaBilgileri.teklifToplami }} TL</td>
                  <td class="p-25"> {{ item.firmaBilgileri.teklifToplamiKDVli }} TL</td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="text-center">
              <p class="font-size-13">{{ bilgiler.belgeTarih }} tarihinde yapılan ihaleye {{ teklifler.length }}
                ({{
                  teklifler.length == 0 ? 'sıfır' : teklifler.length == 1 ? 'bir' : teklifler.length == 2 ? 'iki' : teklifler.length == 3 ? 'üç' : teklifler.length == 4 ? 'dört' : teklifler.length == 5 ? 'beş' : ''
                }}) istekli
                katılmış olup, teklif verenlerin adı soyadı ve unvanı yukarıda belirtilmiştir.
              </p>
            </b-col>
            <b-col cols="12" class="p-50 text-center">
              <p class="font-size-15">İHALE KOMİSYONU</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th v-for="uye in lodash.orderBy(evraklar(9).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo" scope="col"
                  >Komisyon Üyesi
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="uye in lodash.orderBy(evraklar(9).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                  ><p class="mb-1 text-center text-decoration-underline font-size-13">{{ uye.gorev }}</p>
                    <p class="m-0 text-center font-weight-bolder font-size-13">{{ uye.adSoyad }}</p>
                    <p class="m-0 text-center font-weight-bold font-size-13">{{ uye.unvan }}</p></td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="text-center pt-2">
              <p class="p-0 m-0 font-size-14">Bilgim Vardır.</p>
            </b-col>
            <b-col cols="12" class="text-center ">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.belgeTarih }}</p>
            </b-col>
            <b-col cols="12" class="text-center " v-if="bilgiler.ihaleYetkilisi">
              <p class="pt-50 m-0 font-weight-bolder font-size-14">{{ bilgiler.ihaleYetkilisi }}</p>
            </b-col>
            <b-col cols="12" class="text-center ">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.yetkiliUnvan }}</p>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        v-if="enAvantajliTeklif && teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID)"
        id="evrak10"
        ref="modal10"
        centered
        size="xl"
        hide-footer
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('karar-tutanagi')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('karar-tutanagi-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="İhale Komisyon Karar Tutanağı"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="karar-tutanagi"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="karar-tutanagi-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-1">
              <p class="text-center font-size-17">İHALE KOMİSYON KARAR TUTANAĞI</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder">İhale Kayıt No : {{ bilgiler.belgeTarihSayi }}</p>
              <p class="font-weight-bolder">İdarenin Adı : {{ $store.getters.FIRMA_BILGILERI.tamUnvan }}</p>
              <p class="font-weight-bolder">İşin Adı : {{ bilgiler.ihaleBaslik }}</p>
              <p class="font-weight-bolder">İhale Tarih ve Saati : {{ bilgiler.kayitTarih.slice(0, 16) }}</p>
              <p class="font-weight-bolder">İhale Usulü : {{ detay.ihaleUsulu }}</p>
              <p class="font-weight-bolder">Toplam Teklif Sayısı : {{ teklifler.length }} ({{
                  teklifler.length === 1 ? 'Bir' : teklifler.length === 2 ? 'İki' : teklifler.length === 3 ? 'Üç' : teklifler.length === 4 ? 'Dört' : 'Beş' || ''
                }})</p>
              <p class="font-weight-bolder">Geçerli Teklif Sayısı : {{ teklifler.length }} ({{
                  teklifler.length === 1 ? 'Bir' : teklifler.length === 2 ? 'İki' : teklifler.length === 3 ? 'Üç' : teklifler.length === 4 ? 'Dört' : 'Beş' || ''
                }})</p>
              <hr>
            </b-col>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th scope="col">Ekonomik Açıdan En Avantajlı Teklifin</th>
                <th scope="col">Ekonomik Açıdan En Avantajlı İkinci Teklifin</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td v-if="enAvantajliTeklif[0]">
                  <p class="d-inline-block m-0 font-size-13">
                    a) Sahibinin Adı :
                  </p>
                  <p class="font-weight-bolder d-inline-block m-0 pl-2 font-size-13">
                    {{ enAvantajliTeklif[0].name }}
                  </p>
                  <br>
                  <p class="d-inline-block m-0 font-size-13">
                    b) Tutarı :
                  </p>
                  <p class="font-weight-bolder m-0 d-inline-block pl-2 font-size-13">
                    {{
                      Number(enAvantajliTeklif[0].teklif)
                          .toFixed(2)
                    }}
                    TL
                  </p>
                </td>
                <td v-if="enAvantajliTeklif[1]">
                  <p class="d-inline-block m-0 font-size-13">
                    a) Sahibinin Adı :
                  </p>
                  <p class="font-weight-bolder d-inline-block m-0 pl-2 font-size-13">
                    {{ enAvantajliTeklif[1].name }}
                  </p>
                  <br>
                  <p class="d-inline-block m-0 font-size-13">
                    b) Tutarı :
                  </p>
                  <p class="font-weight-bolder m-0 d-inline-block pl-2 font-size-13">
                    {{
                      Number(enAvantajliTeklif[1].teklif)
                    }}
                    TL
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
            <b-col cols="12" class="pt-25">
              <p class="font-size-13">Bu tutanağın düzenlendiği tarih ve saat : {{
                  bilgiler.kayitTarih.slice(0, 16)
                }}</p>
            </b-col>
            <b-col cols="12" class="pt-25">
              <p class="text-center font-size-15">İSTEKLİLERİN TEKLİF ETTİĞİ BEDELLER</p>
            </b-col>
            <b-col cols="12" class="mt-25">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th scope="col">İsteklinin Adı</th>
                  <th scope="col">Teklif Edilen Bedel (KDV Dahil)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in enAvantajliTeklif" :key="i">
                  <td> {{ item.name }}</td>
                  <td>{{ Number(item.teklif.toFixed(2)) }} TL</td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="p-1">
              <p class="font-size-13">Kurumumuz {{ $store.getters.FIRMA_BILGILERI.tamUnvan }} Müdürlüğüne
                “{{
                  bilgiler.ihaleBaslik
                }}” satın
                almak üzere ihale edilmiş olup, “{{
                  bilgiler.ihaleBaslik
                }}” İhalesine {{ teklifler.length }}
                ({{
                  teklifler.length === 1 ? 'Bir' : teklifler.length === 2 ? 'İki' : teklifler.length === 3 ? 'Üç' : teklifler.length === 4 ? 'Dört' : 'Beş' || ''
                }}) İstekli teklif zarfı
                vermiştir. Alınan teklif zarfları istekliler ve Komisyonumuz huzurunda incelenerek {{
                  teklifler.length
                }}
                ({{
                  teklifler.length === 1 ? 'Bir' : teklifler.length === 2 ? 'İki' : teklifler.length === 3 ? 'Üç' : teklifler.length === 4 ? 'Dört' : 'Beş' || ''
                }}) teklif zarfı
                geçerli sayılmış, geçerli sayılan teklif zarfları istekliler ve Komisyonumuz huzurunda açılarak, istenen
                belgeler ve teklif fiyatları incelenerek idari ve teknik şartnameye göre geçerli olanlar kabul
                edilmiştir. Geçerli tekliflerden ekonomik açıdan en avantajlı iki teklif yukarıda belirtilmiştir.
                Birinci teklifin ekonomik açıdan en avantajlı teklif olması nedeniyle en düşük fiyat esasına göre
                birinci teklif sahibinden
                "{{
                  teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.firmaUnvan
                }}"
                nden satın alınmasına
                komisyonumuzca karar
                verilerek, ita amirinin onayına arz olundu. {{ bilgiler.belgeTarih }}
              </p>
            </b-col>
            <b-col cols="12" class="pt-50">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th v-for="uye in lodash.orderBy(evraklar(9).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo" scope="col" class="text-center"
                  >Komisyon Üyesi
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="uye in lodash.orderBy(evraklar(9).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                  >
                    <p class="text-center text-decoration-underline font-size-14">{{ uye.gorev }}</p>
                    <p class="m-0 text-center font-weight-bolder font-size-14">{{ uye.adSoyad }}</p>
                    <p class="m-0 text-center font-weight-bold font-size-14">{{ uye.unvan }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="text-center">
              <p class="p-0 m-0 font-size-14">Uygundur.</p>
            </b-col>
            <b-col cols="12" class="text-center">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.belgeTarih }}</p>
            </b-col>
            <b-col cols="12" class="text-center" v-if="bilgiler.ihaleYetkilisi">
              <p class="pt-50 m-0 font-weight-bolder font-size-14">{{ bilgiler.ihaleYetkilisi }}</p>
            </b-col>
            <b-col cols="12" class="text-center" v-if="bilgiler.yetkiliUnvan">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.yetkiliUnvan }}</p>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak11"
        ref="modal11"
        centered
        size="xl"
        hide-footer
        v-if="teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID)"
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('temin-sozlesmesi')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('temin-sozlesmesi-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Doğrudan Temin Sözleşmesi"
          :pdf-quality="2"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="temin-sozlesmesi"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="temin-sozlesmesi-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="2"/>
            <b-col cols="8" class="mb-2">
              <p class="text-center font-size-17">
                4734 SAYILI KAMU İHALE KANUNUN 22/D
                {{ detay.ihaleUsulu }} USULÜ İLE ALIMA AİT SÖZLEŞME
                ( Mal Alımı Sözleşmesi )
              </p>
            </b-col>
            <b-col cols="2"/>
            <b-col cols="12">
              <p class="font-weight-bolder font-size-14">Madde 1 – Sözleşmenin Tarafları</p>
            </b-col>
            <b-col cols="12">
              <p>Bu sözleşme, bir tarafta {{ $store.getters.FIRMA_BILGILERI.unvan }} MÜDÜRLÜĞÜ
                (bundan sonra “İdare”
                olarak anılacaktır.)
                ile diğer tarafta
                {{
                  teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.firmaAdi
                }}
                (bundan sonra “Yüklenici” olarak anılacaktır.) arasında
                aşağıda yazılı şartlar dahilinde akdedilmiştir.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder font-size-14">Madde 2 –Taraflara İlişkin Bilgiler</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder">2.1. İdarenin Adresi : </p>
            </b-col>
            <b-col cols="12">
              <p class="mb-50">{{ $store.getters.FIRMA_BILGILERI.adres }}</p>
              <b-col cols="12">
                <b-row>
                  <b-col cols="3" class="p-0">
                    <p class="m-0 m-0">Telefon / Faks</p>
                  </b-col>
                  <b-col cols="9" class="p-0">
                    <p class="font-weight-bolder m-0 m-0"> : {{ $store.getters.FIRMA_BILGILERI.telefon }} </p>
                  </b-col>
                  <b-col cols="3" class="p-0">
                    <p class="m-0 m-0">E-Posta Adresi </p>
                  </b-col>
                  <b-col cols="9" class="p-0">
                    <p class="font-weight-bolder m-0 m-0"> : {{ $store.getters.FIRMA_BILGILERI.ePosta }} </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder pt-1">2.2. Yüklenicinin Tebligat Adresi : </p>
            </b-col>
            <b-col cols="12">
              <p class="mb-50">
                {{ teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.firmaAdres }}
              </p>
              <b-col cols="12">
                <b-row>
                  <b-col cols="3" class="p-0">
                    <p class="m-0 m-0">Tel. No.</p>
                  </b-col>
                  <b-col cols="9" class="p-0">
                    <p class="font-weight-bolder m-0 m-0"> :
                      {{
                        teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.firmaTelefon
                      }}
                    </p>
                  </b-col>
                  <!--                  <b-col cols="3" class="p-0">-->
                  <!--                    <p class="m-0 m-0">Fax. No.</p>-->
                  <!--                  </b-col>-->
                  <!--                  <b-col cols="9" class="p-0">-->
                  <!--                    <p class="font-weight-bolder m-0 m-0"> : {{ teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.faxNo }} </p>-->
                  <!--                  </b-col>-->
                </b-row>
              </b-col>
            </b-col>
            <b-col cols="12">
              <p class="">2.3. Her iki taraf madde 2.1 ve 2.2 de belirtilen adreslerini tebligat
                adresleri olarak kabul etmişlerdir. Adres değişiklikleri usulüne uygun şekilde karşı tarafa tebliğ
                edilmedikçe en son bildirilen adrese yapılacak tebliğ ilgili tarafa yapılmış sayılır.</p>
            </b-col>
            <b-col cols="12">
              <p class=" font-weight-bolder font-size-14">Madde 3 –Sözleşmenin Konusu </p>
            </b-col>
            <b-col cols="12">
              <p class="">3.1.Sözleşme konusu iş; İdarenin ihtiyacı olan "{{ bilgiler.ihaleBaslik }}"
                sözleşmede
                belirlenen şartlar dahilinde Yüklenici tarafından sağlanması işidir. İşin teknik ayrıntıları ve
                ifasına
                ilişkin detaylar sözleşme ek’inde yer alan ve ihale dokümanını oluşturan belgelerle
                düzenlenmiştir.</p>
            </b-col>
            <b-col cols="12">
              <p class="">3.2. Bu sözleşme ile temin edilecek mal yüklenici tarafından teklif edilen ve idare
                tarafından uygun bulunan /beğenilen numuneye / teknik özelliklere göre teslim edilecektir.</p>
            </b-col>
            <b-col cols="12">
              <p class=" font-weight-bolder font-size-14">Madde 4 – Sözleşmenin Türü Ve Bedeli </p>
            </b-col>
            <b-col cols="12">
              <p class="">Üzerine ihale yapılan istekliyle, her bir iş kaleminin miktarı ile bu iş kalemleri
                için
                teklif edilen birim fiyatların çarpımı sonucu bulunan toplam bedel üzerinden birim fiyat sözleşme
                imzalanacaktır. Sözleşme bedeli {{ Number(enAvantajliTeklif[0].teklif) }} TL bedel üzerinden
                akdedilmiştir.
              </p>
            </b-col>
            <b-col cols="12">
              <p class=" font-weight-bolder font-size-14">Madde 5 – Vergi, Resim Ve Harçlar İle Sözleşmeyle
                İlgili
                Diğer
                Giderler</p>
            </b-col>
            <b-col cols="12">
              <p class="">Taahhüdün yerine getirilmesine ilişkin ulaşım, sigorta, vergi (KDV hariç) resim ve
                harçlar sözleşme bedeline dahildir. İlgili mevzuatı uyarınca hesaplanacak Katma Değer Vergisi sözleşme
                bedeline dahil olmayıp idare tarafından yükleniciye ödenecektir. Ancak 3065 Sayılı Kanunun 13/f
                maddesi
                kapsamına giren işler (Maliye Bakanlığı Gelirler Genel Müdürlüğünce yayımlanan KDV Genel Tebliği
                1.4.3.1. bölümünde yapılan açıklamalar gereği) KDV muafiyeti içerdiğinden bu kapsama giren alımlar
                için
                Katma Değer Vergisi ödenmeyecek olup, ödeme aşamasında yükleniciye bu yönde belge verilecektir.</p>
            </b-col>
            <b-col cols="12">
              <p class=" font-weight-bolder font-size-14">Madde 6 – Malın/İşin Teslim Alma Şekil Ve Şartları İle
                Teslim
                Programı</p>
            </b-col>
            <b-col cols="12">
              <p class="pt-1 font-weight-bolder">6.1. İşin Yapılma / Malın Teslim Edilme Yeri </p>
            </b-col>
            <b-col cols="12">
              <p class=""><p class="m-0 d-inline-block">{{ $store.getters.FIRMA_BILGILERI.tamUnvan }}
                MÜDÜRLÜĞÜ</p>
                İdaresinin göstereceği yere teslim edilecektir.
              </p>
            </b-col>
            <b-col cols="12">
              <p class="">6.2. İşe Başlama Tarihi : Sözleşmenin imzalanmasından itibaren idarenin siparişine
                göre
                teslim başlayacaktır. {{ bilgiler.ihaleBaslik }} kurum olarak ihtiyaç duyuldukça alım
                gerçekleştirilecek ve ödemesi yapılacaktır.
              </p>
            </b-col>
            <b-col cols="12">
              <p class="">6.3. Teslim Şekli : Teslimat {{ bilgiler.ihaleBaslik }} ihtiyaç duyuldukça idare
                tarafından istenecek yüklenici tarafından temin edilecek ve idare tarafından 30 gün içerisinde ödemesi
                yapılacaktır. {{ bilgiler.ihaleBaslik }} nakliyesi ve taşıması yüklenici tarafından
                yapılacaktır.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 7 –Ödeme Yeri Ve Şartları</p>
            </b-col>
            <b-col cols="12">
              <p class="">Bu sözleşmede düzenlenen hata, kusur ve eksikliklere ilişkin hükümler saklı kalmak
                kaydıyla ,teslim edilen malların / işin bedeli, idarenin kesin kabulü ve yüklenicinin faturayı idareye
                teslim etmesini müteakiben düzenlenecek ödeme belgelerine istinaden, Türk Lirası olarak ve Maliye
                Bakanlığınca belirlenen usul ve esaslar dahilinde {{ $store.getters.FIRMA_BILGILERI.unvan }} muhasebe
                bölümünden
                yapılacaktır. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 8–Yüklenicinin Ceza Sorumluluğu</p>
            </b-col>
            <b-col cols="12">
              <p class="">
                İş tamamlandıktan ve kabul işlemi yapıldıktan sonra tespit edilmiş olsa dahi 4734 sayılı Kanunun 17
                inci
                ve 4735 sayılı Kanunun 25 inci maddesinde belirtilen yasak fiil ve davranışlardan Türk Ceza Kanununa
                göre suç teşkil eden fiil ve davranışlarda bulunan Yüklenici, ortak ve vekilleri hakkında yetkili
                Cumhuriyet Savcılığına suç duyurusunda bulunulur.
              </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 9 – Gecikme Cezası</p>
            </b-col>
            <b-col cols="12">
              <p class="">Yüklenici, sözleşmeye uygun olarak malı süresinde teslim etmediği / işi bitirmediği
                takdirde; gecikilen her takvim günü için sözleşme bedelinin binde üçü (3) oranında gecikme cezasına
                tabi
                olacaktır. Ancak bu gecikmenin on(10) günü aşması durumunda ayrıca ihtar / protesto çekmeye gerek
                kalmaksızın sözleşmeyi fesh edip etmemek idarenin etkisindedir.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 10 – Malların Taşınması</p>
            </b-col>
            <b-col cols="12">
              <p class="">Bu sözleşmede düzenlenen işlerin yapılmasına ilişkin her türlü taşıma gideri (kargo)
                sözleşme bedeline dahildir.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 11 – Ambalajlama</p>
            </b-col>
            <b-col cols="12">
              <p class="">Sözleşme konusu mal, örnek numunesinde / idare tarafından belirtilen şekilde orijinal
                ambalajında teslim edilecektir. Malın orijinal olarak ambalajlanmaması nedeniyle meydana gelebilecek
                ve
                sigorta tarafından karşılanmayan hasar, zarar ve eksiklikler Yükleniciye ait olacaktır. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 12 – Mevzuata Uygunluk</p>
            </b-col>
            <b-col cols="12">
              <p class="">Yüklenici, ilgili bütün ihbarların verilmesi ve bütün ödemelerin yapılması da dahil
                olmak üzere,</p>
              <p class=" pl-2">a – İşin yürütülmesine ve tamamlanmasına ve malda olabilecek kusurların
                düzeltilmesine
                ilişkin olarak bütün kanun, yönetmelikler, tüzükler, kararnameler, genelge, tebliğ ve diğer ilgili
                mevzuata,</p>
              <p class=" pl-2">b – Kamu kurum ve kuruluşlarının alacağı kararlar ile Mahkeme kararlarına, uyacak
                ve
                İdareyi bu hükümlerin ihlali nedeniyle maruz kalabileceği bütün cezalardan ve sorumluluklardan dolayı
                tazmin edecektir. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 13 – Yüklenicinin Tazmin Sorumluluğu</p>
            </b-col>
            <b-col cols="12">
              <p class="">Yüklenici, garanti süresi boyunca oluşabilecek arızalardan sorumludur, taahhüdü
                çerçevesinde kusurlu veya standartlara uygun olmayan mal temini, teslimi veya kullanılması, taahhüdün
                sözleşme ve şartname hükümlerine uygun olarak yerine getirilmemesi ve benzeri nedenlerle ortaya çıkan
                zarar ile üçüncü kişilere, çevreye veya idare personeline verilen zarar ve ziyanlardan doğrudan
                sorumludur. Ayrıca haklarında 4735 sayılı kanunun 27 nci maddesi hükümleri uygulanır. Garanti
                hükümlerinin uygulanması ile ilgili ortaya çıkacak ihtilaflar, 28/05/2014 tarih ve 6502 sayılı
                TÜKETİCİNİN KORUNMASI hakkında kanun hükümleri uyarınca ilgili mahkemelerde sonuca
                bağlanacaktır. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 14 – Alımı yapılacak mallar ve miktarları</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th scope="col">Sıra No</th>
                  <th scope="col">Kalem</th>
                  <th scope="col">Miktar</th>
                  <th scope="col">Birim</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in kalemler" :key="item.kalemID">
                  <td class="p-0">{{ i + 1 }}</td>
                  <td class="p-0">{{ item.kalemAdi }}</td>
                  <td class="p-0">{{ item.miktar }}</td>
                  <td class="p-0">{{ item.birimTuru }}</td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12">
              <p class="mt-50">Yüklenicinin malın tamamını, İdareye teslim edildiği tarihten malın kabulüne kadar
                geçen
                süreler için sigorta ettirmemesi halinde ortaya çıkan zararlar Yükleniciye aittir. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 15 –Muayene ve Kabul Şekil ve Şartları </p>
            </b-col>
            <b-col cols="12">
              <p class="">15.1 Denetim, Muayene Ve Kabul İşlemlerine, malın teslim edildiği gün içerisinde
                başlanması esastır. Muayene, teknik konularda uzman görüşüne göre ve Yetkilendirilen Alım Komisyonun
                tamamının katılımı ile yapılır. Yüklenici veya vekilinin hazır bulunması ile Komisyon tarafından,
                teslim
                edilen malların miktarı, malların ya da yapılan işin sözleşmeye uygunluğu bir kabul tutanağı ile
                tespit
                edilir. Tutanak sonucunda komisyon malların kalitesini, varsa hatalı ve kusurlu malların oranını ve
                adedini raporunda belirtir. Komisyon burada yazılanlarla sınırlı olmaksızın, varsa sözleşme dahilinde,
                ilave görüşlerine de raporunda yer verir. </p>
            </b-col>
            <b-col cols="12">
              <p class="">15.2. Her kalem malzeme bir kısım olarak değerlendirildiğinden, idare niteliklerini
                uygun bulduğu kısımları kabul ederek bu kısımlara ait kısmi ödeme yapmakta serbesttir.</p>
            </b-col>
            <b-col cols="12">
              <p class="">15.3 Teslim edilen malın Yetkilendirilen Alım Komisyonunca uygun bulunmaması halinde;
                malın değiştirilmesi / hata ve eksikliğin tamamlatılması veya alımın o aşamada iptal edilmesi idarenin
                yetkisindedir. Bu durumda Yüklenici hiçbir hak talebinde bulunamaz.
              </p>
            </b-col>
            <b-col cols="12">
              <p class="">15.4. Alım onayında muayenenin Teknik Şartnamesine göre ve Muayene Komisyonunca
                yapılacağı belirtilen muayeneler TSK Mal Alımları Denetim, Muayene ve Kabul İşlemleri Yönergesine göre
                yapılacaktır.</p>
            </b-col>
            <b-col cols="12">
              <p class="">15.5. Teslim edilen malın muayene sonucunda reddedilmesi halinde yüklenici muayene
                sonucunun kendisine tebliğ edildiği tarihi takip eden günden itibaren 5(beş) iş günü içerisinde malı
                bulunduğu yerden teslim alıp kaldırmak zorundadır. Aksi halde geçen her gün için sözleşme bedelinin
                %0,05 (onbindebeş) oranında ceza istihkakından kesilecektir</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 16 – Kabulden Sonraki Hata Ve Ayıplardan
                Sorumluluk</p>
            </b-col>
            <b-col cols="12">
              <p class="">Yüklenicinin bu sözleşme gereği teslim ettiği mallarda, malzemenin hileli olmasından
                veya malın teknik gereklerine uygun imal edilmemiş olmasından dolayı zarar ve kayıplar oluştuğu
                takdirde
                bu zarar ve kayıplar, Yükleniciye tamamlattırılır veya ödettirilir.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 17 – Onay Verilmesinin Sorumluluğu Ortadan
                Kaldırmaması</p>
            </b-col>
            <b-col cols="12">
              <p class="">Herhangi bir işin üretim aşamasında ya da teslim öncesi imalat aşamasında denetlenmiş
                olması veya işe onay verilmiş olması, yüklenicinin üstlenmiş olduğu işi bütünüyle projelerine,
                sözleşme
                ve şartnamelerine, teknik ve sanat kurallarına uygun olarak yapmak hususundaki yükümlülüklerini ve bu
                konudaki sorumluluğunu ortadan kaldırmaz. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 18 – Sözleşmenin Feshi :</p>
            </b-col>
            <b-col cols="12">
              <p class="">18.1 Sözleşme yapıldıktan sonra Yüklenicinin taahhüdünden vazgeçmesi veya taahhüdünü,
                sözleşme hükümlerine uygun olarak yerine getirmemesi halinde, idare sözleşmeyi fesheder.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 19 – Anlaşmazlıkların Çözümü</p>
            </b-col>
            <b-col cols="12">
              <p class="">19.1.Bu sözleşme ve eklerinin uygulanmasındandan doğabilecek her türlü anlaşmazlığın
                çözümünde Amasya mahkemeleri ve icra daireleri yetkilidir.</p>
            </b-col>
            <b-col cols="12">
              <p class="">19.2. İleride doğabilecek hukuki ihtilaflarda sözleşme ve eklerinin
                {{ $store.getters.FIRMA_BILGILERI.unvan }} VE
                ASO Müdürlüğündeki onaylı asıl suretleri (aslı gibidir) geçerli olacaktır.</p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 20 – Hüküm Bulunmayan Haller</p>
            </b-col>
            <b-col cols="12">
              <p class="">Bu sözleşme ve eklerinde hüküm bulunmayan hallerde, ilgisine göre 4734 Sayılı Kanun ve
                4735 Sayılı Kanun hükümlerine, bu Kanunlarda hüküm bulunmaması halinde ise genel hükümlere göre
                hareket
                edilir.</p>
            </b-col>
            <b-col cols="12">
              <p class=" font-size-14">Madde 21– Bu sözleşme taraflarca imzalandığı tarihte yürürlüğe
                girer. </p>
            </b-col>
            <b-col cols="12">
              <p class="font-weight-bolder  font-size-14">Madde 22– Bu sözleşme 22 (yirmi iki) maddeden ibaret
                olup, İdare ve
                Yüklenici tarafından tam olarak okunup anlaşıldıktan sonra {{ bilgiler.belgeTarih }} tarihinde imza
                altına
                alınarak 1
                (bir) adet düzenlenmiş olup onaylı bir örneği yükleniciye teslim edilmiştir.</p>
            </b-col>
            <b-col cols="12">
              <table class="table table-borderless mt-1">
                <thead>
                <tr>
                  <th class="text-center" scope="col">Yüklenici</th>
                  <th class="text-center" scope="col">İdare</th>
                </tr>
                </thead>
                <tbody>
                <tr class="text-center">
                  <td class="text-center">{{ bilgiler.belgeTarih }}</td>
                  <td class="text-center">{{ bilgiler.belgeTarih }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </b-col>

          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
    <b-modal
        id="evrak12"
        ref="modal12"
        centered
        size="xl"
        hide-footer
        v-if="teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID)"
    >
      <b-button
          v-if="show"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="download('teslim-alma')"
          class="float-right border-0"
      >
        İndir yada Yazdır
      </b-button>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right border-0 mr-50"
          @click="download('teslim-alma-formu')"
      >
        Word olarak indir
      </b-button>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Malzeme Talep Formu"
          :pdf-quality="pdfQuality"
          :manual-paginaton="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="teslim-alma"
          id="html2Pdf"
      >
        <section slot="pdf-content" class=" pl-2 pr-2" ref="teslim-alma-formu">
          <b-row class="p-2 pr-5 pl-5" v-if="show">
            <b-col cols="12" class="mb-2">
              <p class="text-center font-size-17 mt-4">MUAYENE ve TESLİM ALMA KOMİSYON TUTANAĞI</p>
            </b-col>
            <b-col cols="12">
              <p class="my-50 font-size-14">{{ bilgiler.belgeTarih }} tarihli ve {{ bilgiler.belgeTarihSayi }}
                sayılı {{ detay.ihaleUsulu }} ile
                {{
                  teklifler.find(x => x.firmaBilgileri.firmaID == bilgiler.firmaID).firmaBilgileri.firmaAdi
                }}
                ’nden
                satın alınan aşağıdaki tabloda cinsi ve miktarı belirtilen malzemelerin muayenesi ve kontrolü
                komisyonumuzca yapılmış olup, {{ bilgiler.belgeTarih }} tarihinde eksiksiz olarak teslim
                alınmıştır. </p>
            </b-col>
            <b-col cols="12" class="mt-2">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th scope="col">Sıra No</th>
                  <th scope="col">Malzeme Adı</th>
                  <th scope="col"> Miktarı</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,i) in kalemler" :key="item.kalemID">
                  <td class="p-0"> {{ i + 1 }}</td>
                  <td class="p-0"> {{ item.kalemAdi }}</td>
                  <td class="p-0">{{ item.miktar }} {{ item.birimTuru }}</td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="pb-1 pt-1">


              <table class="table">
                <thead>
                <tr>
                  <th v-for="uye in lodash.orderBy(evraklar( 11).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo" scope="col"
                  >Üye
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="uye in lodash.orderBy(evraklar( 11).evrakUyeleri, 'sira', 'asc')"
                      :key="uye.siraNo"
                  >
                    <p class="text-center text-decoration-underline font-size-14">{{ uye.gorev }}</p>
                    <p class="m-0 text-center font-weight-bolder font-size-14">{{ uye.adSoyad }}</p>
                    <p class="m-0 text-center font-weight-bold font-size-14">{{ uye.unvan }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="12" class="text-center pt-3">
              <p class="p-0 m-0 font-size-14">Bilgim Vardır.</p>
            </b-col>
            <b-col cols="12" class="text-center ">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.belgeTarih }}</p>
            </b-col>
            <b-col cols="12" class="text-center" v-if="bilgiler.ihaleYetkilisi">
              <p class="pt-50 m-0 font-weight-bolder font-size-14">{{ bilgiler.ihaleYetkilisi }}</p>
            </b-col>
            <b-col cols="12" class="text-center" v-if="bilgiler.yetkiliUnvan">
              <p class="p-0 m-0 font-size-14">{{ bilgiler.yetkiliUnvan }}</p>
            </b-col>
          </b-row>
          <b-row v-if="!show">
            <b-col cols="12">
              <p class="text-center">Bekleyiniz...</p>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-modal>
  </section>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardHeader,
  BCardText,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BFormTextarea, BImg,
  BInputGroup,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BMedia,
  BMediaAside,
  BMediaBody,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import VueHtml2pdf from 'vue-html2pdf'
import _ from 'lodash'
import flatpickr from 'flatpickr'
import HTMLtoDOCX from 'html-to-docx'

const Turkish = require('flatpickr/dist/l10n/tr.js').default.tr
flatpickr.localize(Turkish)
flatpickr(flatPickr)

export default {
  components: {
    VueHtml2pdf,
    BCollapse,
    BDropdownItem,
    BDropdown,
    BImg,
    BForm,
    vSelect,
    BFormInvalidFeedback,
    BPagination,
    BInputGroupPrepend,
    BTab,
    BTabs,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BFormTextarea,
    flatPickr,
    BCard,
    BCardText,
    BContainer,
    BFormSelect,
    BBadge,
    BTable,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BButton,
    BRow,
    BCol,
    BCardHeader,
    BCardActions,
  },
  data() {
    return {
      lodash: _,
      show: false,
      tableData: [],
      teklifKalemleri: [],
    }
  },
  props: ['bilgiler', 'detay', 'uyeler', 'kalemler', 'teklifler'],
  computed: {
    currentYear() {
      const date = new Date()
      return date.getFullYear()
    },
    enAvantajliTeklif() {
      if (this.teklifler) {
        const avantajList = []
        this.teklifler.forEach(item => {
          const fiyat = item.firmaBilgileri.teklifToplamiKDVli
          avantajList.push({
            name: item.firmaBilgileri.firmaUnvan,
            teklif: fiyat,
          })
        })
        return _.orderBy(avantajList, 'teklif', 'asc')
      } else {
        return false
      }
    },
    yaklasikMaliyet() {
      if (store.getters.IHALE_DETAY_GET.yaklasikMaliyet) {
        return store.getters.IHALE_DETAY_GET.yaklasikMaliyet
      }
      return []
    },
  },
  methods: {
    getTeklifBirimFiyat(teklifler, kalemID) {
      if (teklifler.teklifler) {
        return teklifler.teklifler.find(x => x.kalemID === kalemID).birimFiyat
      }
      return ''
    },
    formatFirmaBilgileri(firmaBilgileri) {
      const {
        // firmaAdi,
        firmaUnvan,
      } = firmaBilgileri
      let formattedFirmaBilgileri = ''
      // if (firmaAdi && firmaAdi.length > 10) {
      //     formattedFirmaBilgileri += this.breakLines(firmaAdi)
      // } else {
      //     formattedFirmaBilgileri += firmaAdi
      // }
      if (firmaUnvan && firmaUnvan.length > 10) {
        formattedFirmaBilgileri += this.breakLines(firmaUnvan)
      } else {
        formattedFirmaBilgileri += firmaUnvan
      }
      return formattedFirmaBilgileri
    },
    breakLines(text) {
      let formattedText = ''
      const words = text.split(' ')
      for (let i = 0; i < words.length; i++) {
        formattedText += `${words[i]} `
        // if ((i + 1) % 10 === 0) {
        //   formattedText += '<br>'
        // }
      }
      return formattedText
    },
    evraklar(evrakNo) {
      const evrakUyeleri = this.uyeler.filter(evrak => evrak.evrakNo == evrakNo)
      const sira = []
      evrakUyeleri.forEach(item => {
        sira[`sira${item.sira}`] = item
      })
      return {
        sira,
        evrakUyeleri,
      }
    },
    async download(ref) {
      if (ref.includes('formu')) {
        const content = this.$refs[ref].innerHTML
        const fileBuffer = await HTMLtoDOCX(content)
        const blob = new Blob([fileBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = ref
        a.click()
        window.URL.revokeObjectURL(url)
      } else {
        this.$refs[ref].generatePdf()
      }
    },
  },
  mounted() {
    // Todo Modal Acilinca PDF Duzenlenmesi Icin Tarayıcı Design Mode Geciyor
    const modals = ['modal1', 'modal2', 'modal3', 'modal4', 'modal5', 'modal6', 'modal7', 'modal8', 'modal9', 'modal10', 'modal11', 'modal12']
    modals.forEach(modal => {
      if (this.$refs[modal] != undefined) {
        this.$refs[modal].$on('hidden', () => {
          document.designMode = 'off'
        })
        this.$refs[modal].$on('shown', () => {
          document.designMode = 'on'
        })
      }
    })
  },
  created() {
    if (this.uyeler) {
      setTimeout(() => {
        this.show = true
      })
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
}
</script>

<style lang="scss">
.custom-box {
  height: 20px;
  width: 20px;
  border: 1px solid grey;
  border-radius: 5px;
  display: inline-block;
  transform: translate(10px, 2px);
}

.custom-box-checked {
  height: 20px;
  width: 20px;
  border: 1px solid grey;
  border-radius: 5px;
  display: inline-block;
  transform: translate(10px, 2px);
  position: absolute;
}

.custom-box-checked::after {
  position: relative;
  content: url('../../../assets/images/buro/material/check-icon.png');
  top: -10px;
}

.evrak4-firmalar {
  writing-mode: vertical-rl !important;
  transform: rotate(180deg);
  padding: 5px !important;
  //max-height: 25%;
  text-align: center;
}

.layout-container .content-wrapper {
  display: contents !important;
}

#html2Pdf {
  margin: 0% 15%;
}

.text-decoration-underline {
  text-decoration: underline;
}

.other-organizasyon {
  height: 35px;
}

</style>
<style>
.fiyat-arastirma-td-1 {
  width: 5%;
}

.fiyat-arastirma-td-2 {
  width: 25%;
}

.fiyat-arastirma-td-3 {
  width: 15%;
}

.fiyat-arastirma-td-4 {
  width: 10%;
}

.fiyat-arastirma-td-5 {
  width: 20%;
}

.fiyat-arastirma-td-6 {
  width: 25%;
}

.fiyat-arastirma-tr {
  padding-top: 2px;
  display: flex;
}

.fiyat-arastirma-td-last {
  width: 80%;
  border: 1px solid #f2f2ff
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

#evrak1 p {
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.p-25 {
  padding: 0.25rem;
}

@media screen {
  .border {
    border: 1px solid #dbd8e3 !important;
  }
}

.full-place-center {
  place-items: center;
  display: flex;
  place-content: center;
}
</style>
